<script lang="ts">
	// IMPORTS
	import Block from '$components/Block/Block.svelte';

	// PROPS
	export let note: string;
	export let credits: Array<string>;
</script>

<Block id="{'credits'}" width="full-width">
	<div class="CreditBox">
		<div class="CreditBox__note">{note}</div>
		<div class="CreditBox__credits">
			{#each credits as credit}
				<div class="CreditBox__credit">{credit}</div>
			{/each}
		</div>
	</div>
</Block>

<style lang="scss">
	@use '$styles/mq' as *;
	@use '$styles/colors' as *;

	:global(#credits) {
		margin-top: 0;
		margin-bottom: 0;
		background: var(--theme-primary);
		padding: 0 32px 32px 32px;
	}

	.CreditBox {
		margin: 0 auto;
		max-width: 500px;
	}

	.CreditBox__note {
		margin-bottom: 16px;
		color: var(--theme-secondary);
		font-family: var(--brand-font-copy);
	}

	.CreditBox__credits {
		border-radius: 5px;
		background: $gray-8;
		padding: 32px;
		color: $gray-3;

		.CreditBox__credit {
			margin-bottom: 1rem;
			line-height: 1.5;

			&:last-child {
				margin-bottom: 0;
			}
		}
	}
</style>
